import { Alert, AlertContext, Builder_, Confirmation_, device, Dropdown_, Filled_Edit, Form, FormBox, FormBoxSelection, FormBoxTitle, Grey_, Grey_Link, Input_, LimitCharacters, Main_, Main_Plain, Slider_, Textarea_ } from 'monica-alexandria'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components';
import b from "../../../services/api/Boards";
import l from "../../../services/api/Landings";
import { alertMessage } from '../../../utils/messagesAlerts';
import Crm_Lead_Notes from './Crm_Lead_Notes';
import Lead_Editor_Layout from './Lead_Editor_Layout';
import Input_Phone from './Input_Phone';
import LeadCustomFields from './LeadCustomFields';
import { getLeadCustomFieldsError, leadCustomFieldPayload } from '../customFieldAnswers';
import store from '../../../redux/store';
import { CALL_FOLLOW_UP_FIELD, toDateTimeLocalValue } from '../callFollowUp';
import { Calendar_Field } from '../../../components/form/Calendar_Field';
import { getLeadCreationErrors, getLeadFieldError } from '../leadCreateValidation';

const CrmEditLead = styled.div`
  select{
     background: ${(p) => p.bg || p.theme.mid};

     option{
      background: ${p=> p.theme.mid};
     }
  }
`

const LeadActionsWrapper = styled.div`
  position: relative;
  width: 100%;
  
`
const EditFormBox = styled(FormBox)`
  box-shadow: ${p => p.theme.in};

  .Builder{
    grid-template-columns: 1fr 1fr;
  }
`

const EditFormBoxTitle = styled(FormBoxTitle)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`


const LeadActions = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  margin-bottom: 2rem;
  border-bottom: 1px solid color-mix(in srgb, ${(p) => p.theme.color} 12%, transparent);

  .leadView {
    display: none;
  }

  @media ${device.md} {
    .leadView {
      display: block;
    }
  }
`

const LeadTab = styled(Main_Plain)`
  position: relative;
  min-height: 4.8rem;
  padding: 0 2.4rem !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;

  span, h5, p {
    color: ${(p) => p.active ? "var(--main)" : p.theme.color} !important;
  }

  svg {
    fill: ${(p) => p.active ? "var(--main)" : p.theme.color} !important;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: ${(p) => p.active ? "var(--main)" : "transparent"};
  }

  &:hover {
    background: transparent !important;

    span, h5, p {
      color: var(--main) !important;
    }
  }
`

const CallFollowUpBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

const NativeDateTimeInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.background};
  color: ${(p) => p.theme.color};
  box-shadow: ${(p) => p.theme.in};
  padding: var(--normalPads);
  font-size: var(--normalText);
`;

const CallFormFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding-top: 1.6rem;
  border-top: 1px solid color-mix(in srgb, ${(p) => p.theme.color} 12%, transparent);
`;

const CallFormError = styled.p`
  margin: 0;
  color: var(--error, #d85858);
`;

const CallFollowUpSummary = styled(FormBox)`
  box-shadow: ${(p) => p.theme.in};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
`;


export default function Crm_Create_Lead(props) {

    const {t} = useTranslation();
    const isWon = props.activeColumnId === 'won';
    const [selectedQuest, setSelectedQuest]= useState({id:props.selectedQuestId,data:''})
    const [activeTab, setActiveTab] = useState("details")
    const [showCallScheduler, setShowCallScheduler] = useState(false);
    const [useNativeDatePicker, setUseNativeDatePicker] = useState(false);
    const [callDraft, setCallDraft] = useState({ scheduledAt: "", assignedTo: null, note: "" });
    const [scheduledCall, setScheduledCall] = useState(null);
    const [callFormError, setCallFormError] = useState("");
    const currentUser = store.getState()?.user?.user || {};
    const currentUserId = currentUser?.sub || "";
    const currentUserEmail = typeof currentUser?.email === "string"
      ? currentUser.email : currentUser?.email?.email || "";
    const currentUserName = [currentUser?.firstname, currentUser?.lastname].filter(Boolean).join(" ").trim() || currentUserEmail;
    const scheduleUsers = (props.scheduleUsers || []).filter((user, index, users) => {
      const key = String(user?.userId || user?.id || user?.email || "").toLowerCase();
      return key && users.findIndex((candidate) => String(candidate?.userId || candidate?.id || candidate?.email || "").toLowerCase() === key) === index;
    });
    // const [localNotes, setLocalNotes] = useState([]);
    const [text, setText] = useState("");
    const [newLead, setNewLead] = useState({
      values: {},
      Notes: [],
      Amount: "",
      Country: "GR",
    })
    const [touchedFields, setTouchedFields] = useState({});
    const [saveAttempted, setSaveAttempted] = useState(false);
    const [customFields, setCustomFields] = useState([]);
    const [customFieldError, setCustomFieldError] = useState('');
    useEffect(() => { setCustomFields([]);setCustomFieldError(''); }, [props.selectedQuestId]);
    const [editingFields, setEditingFields] = useState({});

    const {alerts, setAlerts} = useContext(AlertContext);

    const name = props?.editingLead?.FullName || [
      props?.editingLead?.Name,
      props?.editingLead?.Surname
    ].filter(Boolean).join(" ") 
    || "";


    const isDefined = (field) =>{
        return Object.prototype.hasOwnProperty.call(props.editingLead || {}, field)
    }

   const updateLeadField = (field, value) => {
        console.log('field', field, value);
        setNewLead({ ...props.editingLead, [field]: value })
    }


    const updateCustomFieldRow = (index, key, value) => {
      const updatedFields = [...(props.editingLead?.CustomField || [])];
      updatedFields[index] = {
        ...updatedFields[index],
        [key]: value
      };
      setNewLead({ 
        ...props.editingLead, 
        CustomField: updatedFields 
      });
  };
    
  const getQuestLabel = (quest) => {
    if (!quest) return "";

    if (quest?.name) return quest.name;

    return `${quest?.questionnaires?.[0]?.answer || ""} ${
      LimitCharacters(quest?.questionnaires?.[1]?.answer || "", 15)
    } | ${LimitCharacters(quest?.Meta?.facebookPageName || "", 15)}`;
  };


  const handleSelectedQuest = (qId) => {

    const q= props.quests?.find(q => q._id === qId)

    setSelectedQuest({id:qId, data:q})
  }

const readFollowUpActor = () => ({ userId: currentUserId, email: currentUserEmail, name: currentUserName });

const getDefaultCallAssignee = () => {
  const user = scheduleUsers.find((candidate) =>
    String(candidate?.userId || "") === String(currentUserId || "")
    || String(candidate?.email || "").toLowerCase() === currentUserEmail.toLowerCase()
  ) || scheduleUsers[0];
  return user ? {
    userId: user.userId || user.id || "",
    email: user.email || "",
    name: user.name || [user.firstname, user.lastname].filter(Boolean).join(" "),
  } : readFollowUpActor();
};

const openCallScheduler = () => {
  setCallDraft({
    scheduledAt: scheduledCall?.scheduledAt || "",
    assignedTo: scheduledCall?.assignedTo || getDefaultCallAssignee(),
    note: scheduledCall?.note || "",
  });
  setCallFormError("");
  setShowCallScheduler(true);
};

const buildScheduledCall = () => {
  const date = callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null;
  if (!date || Number.isNaN(date.getTime())) {
    setCallFormError(t("Choose a date and time"));
    return null;
  }
  if (date.getTime() <= Date.now()) {
    setCallFormError(t("Choose a future date and time"));
    return null;
  }

  const now = new Date().toISOString();
  const dateChanged = !scheduledCall || new Date(scheduledCall.scheduledAt).getTime() !== date.getTime();
  const history = [...(scheduledCall?.history || [])];
  if (dateChanged) history.push({
    type: scheduledCall ? "rescheduled" : "scheduled",
    fromScheduledAt: scheduledCall?.scheduledAt || "",
    toScheduledAt: date.toISOString(),
    at: now,
    by: readFollowUpActor(),
  });
  return {
    status: "scheduled",
    scheduledAt: date.toISOString(),
    assignedTo: callDraft.assignedTo || getDefaultCallAssignee(),
    note: String(callDraft.note || "").trim(),
    completedAt: "",
    completedBy: "",
    history: history.slice(-50),
    updatedAt: now,
    updatedBy: currentUserId || currentUserEmail,
  };
};

const stageCall = () => {
  const call = buildScheduledCall();
  if (!call) return;
  setScheduledCall(call);
  setCallFormError("");
  setShowCallScheduler(false);
};

useEffect(() => {
  const media = window.matchMedia(device.md.replace("@media ", ""));
  const updatePicker = () => setUseNativeDatePicker(media.matches);
  updatePicker();
  media.addEventListener("change", updatePicker);
  return () => media.removeEventListener("change", updatePicker);
}, []);

const hasAnyValue = (call) => {
  // system fields
  const hasSystemValue = Object.values(newLead.values || {}).some(
    v => typeof v === "string" && v.trim() !== ""
  );

  // amount
  const hasAmount = typeof newLead.Amount === "string" && newLead.Amount.trim() !== "";

  // notes
  const hasNotes = Array.isArray(newLead.Notes) && newLead.Notes.some(
    n => n.text && n.text.trim() !== ""
  );

  return hasSystemValue || hasAmount || hasNotes || Boolean(call) ||
    (props.isStandaloneBoard && customFields.some(field => String(field.value ?? '').trim()));
};

const saveLead = async () => {
  const extraError = props.isStandaloneBoard ? getLeadCustomFieldsError(customFields, t) : '';
  setCustomFieldError(extraError);
  if (extraError) { setActiveTab('details');return; }
  const fieldErrors = getLeadCreationErrors(props.formSchema || [], newLead.values, t);
  setSaveAttempted(true);
  setEditingFields({});
  if (Object.keys(fieldErrors).length) {
    setActiveTab('details');
    return;
  }
  let call = scheduledCall;
  if (showCallScheduler && (callDraft.scheduledAt || callDraft.note.trim() || scheduledCall)) {
    call = buildScheduledCall();
    if (!call) {
      setActiveTab("schedule");
      return;
    }
  }
  if (call && new Date(call.scheduledAt).getTime() <= Date.now()) {
    setCallFormError(t("Choose a future date and time"));
    setActiveTab("schedule");
    setShowCallScheduler(true);
    return;
  }
  if (!hasAnyValue(call)) return props.onClose();
  const payload = preparePayload(call);

  try {
    const res = await l.createLead(payload);
    const createdLead = res?.data?.form;
    const colId = props.activeColumnId;

    if (!createdLead?._id) {
      throw new Error("Lead was not created");
    }

    // 1️⃣ Persist notes (if any)
    let persistedNotes = [];

    if (newLead?.Notes?.length) {
      for (const note of newLead.Notes) {
        if (!note.text?.trim()) continue;

        const saved = await l.addNote(createdLead._id, note.text);
        const normalizedNote = saved?.data?.note || saved?.data;
        if (
          normalizedNote &&
          typeof normalizedNote === "object" &&
          normalizedNote.text !== undefined
        ) {
          persistedNotes.push(normalizedNote);
        }
      }
    }

    // 2️⃣ Build FINAL lead object (THIS is the key)
    const finalLead = {
      ...createdLead,
      Notes: persistedNotes,
    };

    // 3️⃣ Update board with FULL lead (including notes)
    props.onLeadCreated(finalLead, colId);

    alertMessage(alerts, setAlerts, t("Lead created successfully"), "Success");
    props.onClose();

  } catch (err) {
    console.error("Create lead failed:", err);
    alertMessage(alerts, setAlerts, t("There was an error"), "Error");
  }
};


//working
 const handleAddNote = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
  
    const tempId = `temp_${Date.now()}`;
  
    const newNote = {
      _tempId: tempId,
      text: trimmed,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      createdBy:  selectedQuest?.data?.userId || null,
    };
  
    // optimistic UI
      
      setNewLead(prev => ({
        ...prev,
        Notes: [newNote, ...(prev.Notes || [])],
      }));
    // props.setLocalNotes(prev => [newNote, ...prev]);
    setText("");
    // setIsComposing(false);
  

  };


const preparePayload = (call) => {
  const payload = {
    landingId: props.selectedQuestId,
    columnId: props.activeColumnId,
    Amount: newLead.Amount || "",
    Country: newLead.Country || "GR",
  };
  if (call) payload[CALL_FOLLOW_UP_FIELD] = call;

  // ✅ ONLY system fields go directly on payload
  (props.formSchema || [])
    .filter(f => !f.isCustom)
    .forEach(f => {
      const value = newLead.values?.[f.key] || "";
      payload[f.key] = String(f.key).toLowerCase() === 'email'
        ? String(value).trim().toLowerCase() : value;
    });

  // ✅ ALL custom fields go into CustomField array
  payload.CustomField = props.isStandaloneBoard ? leadCustomFieldPayload(customFields) : (props.formSchema || [])
    .filter(f => f.isCustom)
    .map(f => ({
      key: f.label,
      value: String(f.type).toLowerCase() === 'email'
        ? String(newLead.values?.[f.key] || '').trim().toLowerCase()
        : newLead.values?.[f.key] || "",
    }));

  return payload;
};

  useEffect(() => {
  if (!props.formSchema?.length) return

  const initialValues = {}
  props.formSchema.forEach(f => {
    initialValues[f.key] = ""
  })

  setNewLead(prev => ({
    ...prev,
    values: initialValues
  }))
}, [props.formSchema])



  const headerActions = (
    <LeadActionsWrapper >
      <LeadActions>
          <LeadTab text={t('Details')} active={activeTab === "details"} onClick={() => setActiveTab("details")} />
          <LeadTab className="leadView" text={t('Notes')} active={activeTab === "notes"} onClick={() => setActiveTab("notes")} />
          <LeadTab text={t('Calls')} active={activeTab === "schedule"} onClick={() => setActiveTab("schedule")} />
      </LeadActions>
    </LeadActionsWrapper>
  )

  const columnSelectContent = (  
    <CrmEditLead bg={props.columns?.[props.activeColumnId]?.color+33}>
        <Builder_>
          <Dropdown_ label={t('Column')}>
            <select
              value={props.activeColumnId}
              onChange={(e) => {
                const newCol = e.target.value;
                props.setActiveColumnId(newCol);
                setNewLead(prev => ({...prev, pendingColumnId: newCol}));
              }}
            >
              {props.columnOrder?.map((colId) => (
                <option key={colId} value={colId}>
                  {props.columns[colId].title}
                </option>
              ))}
            </select>
          </Dropdown_>
        </Builder_>
    </CrmEditLead>
  )


  const getFieldFeedback = (field) => {
    const value = newLead.values?.[field.key];
    const message = getLeadFieldError(field, value, t);
    const showError = !editingFields[field.key] && (touchedFields[field.key] || saveAttempted);
    return {
      errors: showError && message ? [message] : [],
      helpers: !showError && String(value ?? '').trim() && message ? [message] : [],
    };
  };

  const leftContent = (
    <>
      <EditFormBox>
        <EditFormBoxTitle>
          <h4>{t("Lead information")}</h4>
          {/* <Main_ iconLeft='Check' onClick={()=>setNewLead(false)}/> */}
        </EditFormBoxTitle>
        {props.formSchema?.map(field => {
          const feedback = getFieldFeedback(field);
          return (
          <Builder_ key={field.key}>
          {field.key === 'Tel' ? 
            <Input_Phone
              placeholder={field.label || t("Phone number")}
              value={newLead.values?.Tel || ""}
              required={field.required}
              errors={feedback.errors}
              helpers={feedback.helpers}
              onBlur={() => {
                setEditingFields((fields) => ({ ...fields, [field.key]: false }));
                setTouchedFields((fields) => ({ ...fields, [field.key]: true }));
              }}
              onChange={(value) => {
                setEditingFields((fields) => ({ ...fields, [field.key]: true }));
                setNewLead(prev => ({ ...prev, values: { ...prev.values, Tel: value } }))
              }}
            />
          :
            <Input_
              placeholder={field.label}
              value={newLead.values?.[field.key] || ""}
              type={field.key === 'Email' || field.type === 'email' ? 'email' : 'text'}
              required={field.required}
              errors={feedback.errors}
              helpers={feedback.helpers}
              onBlur={() => {
                setEditingFields((fields) => ({ ...fields, [field.key]: false }));
                setTouchedFields((fields) => ({ ...fields, [field.key]: true }));
              }}
              onChange={(e) => {
                setEditingFields((fields) => ({ ...fields, [field.key]: true }));
                setNewLead(prev => ({ ...prev, values: {...prev.values, [field.key]: e.target.value }}));
              }}
            />
          }
          </Builder_>
        )})}
        {props.isStandaloneBoard ? <LeadCustomFields fields={customFields} error={customFieldError}
          onChange={fields => { setCustomFields(fields);setCustomFieldError(''); }} /> : null}
      </EditFormBox>

      {/* <Builder_ title={t("Country")}>
        <Dropdown_ label={t("Country")}>
          <select
            value={newLead.Country || "GR"}
            onChange={(e) =>
              setNewLead((prev) => ({ ...prev, Country: e.target.value }))
            }
          >
            <option value="GR">Greece (GR)</option>
            <option value="CY">Cyprus (CY)</option>
            <option value="OTHER">{t("Other")}</option>
          </select>
        </Dropdown_>
      </Builder_>
     */}
      <Builder_ title={isWon ? t('Enter the deal amount') : t('Enter the estimated deal amount')}>
        <Input_
          placeholder={t("Amount")}
          value={newLead.Amount}
          type="text"
          inputMode="decimal"
          onChange={(e) => {
            const val = e.target.value
            if (val === "" || /^\d*\.?\d*$/.test(val)) {
              setNewLead(prev => ({ ...prev, Amount: val }))
            }
          }}
        />
      </Builder_>
    </>
  )

  const notesContent = (
    <Crm_Lead_Notes
      notes={newLead?.Notes || []}
      setNotes={(updater) =>
        setNewLead(prev => ({
          ...prev,
          Notes: typeof updater === "function"
            ? updater(prev.Notes || [])
            : updater,
        }))
      }
      currentUserId={props.selectedQuest?.data?.userId}
      // leadId={props.editingLead?._id }
      handleAdd={handleAddNote}
      text={text}
      setText={setText}
      mode="create"
    />
  );

  const scheduleContent = showCallScheduler ? (
    <CallFollowUpBox>
      <FormBoxTitle><h4>{scheduledCall ? t("Reschedule call") : t("Schedule call")}</h4></FormBoxTitle>
      <Builder_ title={useNativeDatePicker ? t("Date and time") : undefined}>
        {useNativeDatePicker ? (
          <NativeDateTimeInput
            type="datetime-local"
            value={toDateTimeLocalValue(callDraft.scheduledAt)}
            min={toDateTimeLocalValue(new Date())}
            onChange={(event) => {
              const date = event.target.value ? new Date(event.target.value) : null;
              setCallDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
              setCallFormError("");
            }}
          />
        ) : (
          <Calendar_Field
            label={t("Date and time")}
            selected={callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null}
            defaultDate={callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null}
            onChange={(date) => {
              setCallDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
              setCallFormError("");
            }}
            placeholder={t("Choose date and time")}
            interval={15}
            minDate={new Date()}
          />
        )}
      </Builder_>
      {scheduleUsers.length > 1 ? <Builder_>
        <Dropdown_ label={t("Assigned to")}>
          <select
            value={callDraft?.assignedTo?.userId || callDraft?.assignedTo?.email || ""}
            onChange={(event) => {
              const user = scheduleUsers.find((candidate) => String(candidate?.userId || candidate?.id || candidate?.email || "") === event.target.value);
              setCallDraft((draft) => ({ ...draft, assignedTo: user ? {
                userId: user.userId || user.id || "",
                email: user.email || "",
                name: user.name || [user.firstname, user.lastname].filter(Boolean).join(" "),
              } : getDefaultCallAssignee() }));
            }}
          >
            {scheduleUsers.map((user) => {
              const value = String(user?.userId || user?.id || user?.email || "");
              const label = user?.name || [user?.firstname, user?.lastname].filter(Boolean).join(" ") || user?.email;
              return <option key={value} value={value}>{label}</option>;
            })}
          </select>
        </Dropdown_>
      </Builder_> : null}
      <Builder_ title={t("Agenda")}>
        <Textarea_
          value={callDraft.note || ""}
          placeholder={t("What should you discuss?")}
          onChange={(event) => setCallDraft((draft) => ({ ...draft, note: event.target.value }))}
          rows={3}
        />
      </Builder_>
      {callFormError ? <CallFormError role="alert">{callFormError}</CallFormError> : null}
      <CallFormFooter>
        <Main_ text={t(scheduledCall ? "Save changes" : "Schedule call")} iconLeft="Check" onClick={stageCall} />
        <Grey_Link text={t("Cancel")} iconLeft="Xicon" noPadding onClick={() => {
          setShowCallScheduler(false);
          setCallFormError("");
        }} />
      </CallFormFooter>
    </CallFollowUpBox>
  ) : scheduledCall ? (
    <CallFollowUpSummary filled>
      <div>
        <h4>{t("Next call")}</h4>
        <p>{new Date(scheduledCall.scheduledAt).toLocaleString()}</p>
        {scheduledCall.assignedTo?.name ? <p>{scheduledCall.assignedTo.name}</p> : null}
        {scheduledCall.note ? <p>{scheduledCall.note}</p> : null}
      </div>
      <CallFormFooter>
        <Main_Plain text={t("Edit call")} onClick={openCallScheduler} />
        <Grey_Link text={t("Remove")} onClick={() => setScheduledCall(null)} />
      </CallFormFooter>
    </CallFollowUpSummary>
  ) : (
    <CallFollowUpSummary filled>
      <div><h4>{t("No upcoming call")}</h4></div>
      <Main_Plain text={t("Schedule call")} onClick={openCallScheduler} />
    </CallFollowUpSummary>
  );
      
  return (
      <Lead_Editor_Layout
        title={t("New lead")}
        onSave={saveLead}
        onCancel={props.onClose}
        activeTab={activeTab}
        notesOnRight
        headerActions={headerActions}
        columnSelectContent={columnSelectContent}
        leftContent={leftContent}
        notesContent={notesContent}
        scheduleContent={scheduleContent}
      />
  )
}
